
define('text!templates/widgets/dataGridCells/lDurationCell.html',[],function () { return '<span data-bind="lDuration: $data"></span>';});

